import { v4 as uuidV4 } from 'uuid';
import { SubCondition } from 'dorian-shared/types/branch/HubOption';
import { StepCheckOperatorType } from 'components/pages/Book/MemoryBank/memoryBankTypes';

/** Factory for an empty sub-condition. Used by StateConditionCard and HubOptionState. */
export function createEmptySubCondition(): SubCondition {
  return {
    uuid: uuidV4(),
    variableId: null,
    operator: StepCheckOperatorType.Equal,
    intValue: '',
  };
}
